import { createSearchParams } from 'react-router-dom';
import { isEmbeddedInSmorgCompanion } from './smorg_companion_auth';

export const linkWithQueryParams = (baseLink, queryParams) => {
  if (!queryParams) {
    return baseLink;
  }
  const presentQueryParams = {};
  Object.keys(queryParams).forEach((k) => {
    if (queryParams[k]) {
      presentQueryParams[k] = queryParams[k];
    }
  });
  if (Object.keys(presentQueryParams).length === 0) {
    return baseLink;
  }
  const queryString = `?${createSearchParams(presentQueryParams)}`;
  return `${baseLink}${queryString}`;
};

export const openOutsideLink = (url) => {
  if (isEmbeddedInSmorgCompanion()) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
};
